import { I18n } from '@calendly/i18n'
import { AdminManagedBadge as CUIBadge } from '@calendly/ui/components/admin-managed-badge'

export const AdminManagedBadge = ({ groupManaged }) => {
  const translatedString = groupManaged
    ? I18n.t('publisher.organization.managed_event_types.group_managed_badge')
    : I18n.t('publisher.organization.managed_event_types.admin_managed_badge')

  return (<CUIBadge text={translatedString} />)
}
